import { useContext } from 'react';
import Link from 'next/link';
import { MediaTypeEnum } from 'service/timeline';

import { PostItemContext } from './post-item-context';

const PostTitle = () => {
  const { post } = useContext(PostItemContext);
  let title = post.title || '';
  if (!title && post.media?.[0]?.type === MediaTypeEnum.Audio) {
    title = post.media?.[0]?.data?.title || '';
  }
  if (!title?.trim()) {
    return null;
  }
  const postDetailsUrl = `/${post.user_info?.username}/posts/${post.id}`;
  return (
    <Link
      href={postDetailsUrl}
      className="mb-2 line-clamp-2 cursor-pointer text-lg font-bold hover:underline"
    >
      <h3>{title?.trim()}</h3>
    </Link>
  );
};

export default PostTitle;
